import React from "react";
import {Card} from "../modules/PaymentCycles";

export function PaymentCyclesCardPage(props) {
  return (
    <Card {...props} />
  );
}
